import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline/CssBaseline'
import React from 'react'
import { AnalyticsContext } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from '@/shared/ui/ErrorFallback'
import LoginScreen from '@/pages/loginScreen/LoginScreen'
import { DIProvider } from '@/app/context/DIContext/DIProvider'
import { MainScreen } from '@/pages/mainScreen/MainScreen'
import { GetAppError } from '@/shared/lib'
import { TopMenu } from '@/widgets'
import { CacheProvider } from './context/CacheContext'
import { useApp } from './app/useApp'
import { ComponentsRenderProvider } from '@/app/context/ComponentsRenderContext/ComponentsRenderContext'
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation'

function App(): JSX.Element {
    const {
        appContainerStyle,
        isUserLoggedIn,
        analyticsMethods,
        analyticsLogEvent,
    } = useApp()

    return (
        <FocusContext.Provider value="AppRoot">
            <Box id="MainScreen" sx={appContainerStyle}>
                <DIProvider>
                    <CacheProvider>
                        <CssBaseline />
                        <TopMenu />
                        {/*<Container maxWidth="xl" disableGutters>*/}
                        <AnalyticsContext.Provider
                            value={{ ...analyticsMethods }}>
                            <ErrorBoundary FallbackComponent={ErrorFallback}>
                                <GetAppError logFunction={analyticsLogEvent}>
                                    <Box className="App">
                                        {!isUserLoggedIn ? (
                                            <LoginScreen />
                                        ) : (
                                            <ComponentsRenderProvider>
                                                <MainScreen />
                                            </ComponentsRenderProvider>
                                        )}
                                    </Box>
                                </GetAppError>
                            </ErrorBoundary>
                        </AnalyticsContext.Provider>
                        {/*</Container>*/}
                    </CacheProvider>
                </DIProvider>
            </Box>
        </FocusContext.Provider>
    )
}

export default App
